import { Box, Button } from '@mui/material';
import React, { createContext } from 'react';
import CoordinateDetails from './CoordinateDetails';
import AddressDetails from './AddressDetails';
import { FormProvider, useForm } from 'react-hook-form';
import { CustomerService } from '../../Customer/Service';
import Swal from 'sweetalert2';

const AddAddress = ({customer,onClose,addressList}) => {
    const formMethod = useForm({ 
        mode: "onChange",
        defaultValues:{
          customerId:customer.id,
          fullName:`${customer.profile.firstName || ''} ${customer.profile.middleName || ''} ${customer.profile.lastName || ''}`.replace(/\s+/g, ' ').trim(),
          mobileNumber:customer?.mobileNumber,
          address:'',
          addressType:'',
          apartmentRoadArea:'',
          houseFlatBlockNo:'',
          landmark:'',
          city:'',
          latitude:'',
          longitude:'',
          pincode:'',
          state:'',
          tagName:'',
        }
      });
    const {control, handleSubmit, setValue, formState: { errors ,isDirty},watch,reset} = formMethod;
    const onSubmit = async(data) => {
        console.log(data);
        try{
            Swal.fire({
                title: 'Please Wait...',
                showConfirmButton: false, 
                allowOutsideClick: false,
                allowEscapeKey: false,
                willOpen: () => {
                    Swal.showLoading()
                },
            });
            const createResponse = await CustomerService.addCustomeraddress(data);
            if(createResponse.success == '1'){
                const result = await Swal.fire({
                    title: 'Address added successfully',
                    icon: 'success',
                    showCancelButton: true,
                    showConfirmButton: false,
                    cancelButtonText: 'Close',
                    //close after few seconds
                    timer: 5000,
                    timerProgressBar: true,
                });
                // if(result.isConfirmed){
                //     reset();
                // }
                if(result.isDismissed){
                    onClose();
                }
                
            }else if (createResponse.success == '0'){
                Swal.fire('Failed to add address', '', 'error');
            }

        }catch(error){
            console.log(error);
            Swal.fire('Something went wrong ......', '', 'error');
        }
    }
  return (
    <FormProvider {...formMethod}>
        <Box component={'form'} onSubmit={handleSubmit(onSubmit)}>
            <CoordinateDetails />
            <AddressDetails customer={customer} addressList={addressList}/>
            <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
                <Button size='small' type="submit" variant="contained" color="primary" disabled={!isDirty}>Save</Button>
            </Box>
        </Box>
    </FormProvider>
  );
}

export default AddAddress;
